import { defineStore } from "pinia";

export interface AdminConfirmationRequest {
  title: string;
  message: string;
  confirmLabel?: string | undefined;
  typedConfirmation?: string | undefined;
}

export const useAdminConfirmationStore = defineStore("admin-confirmation", {
  state: (): {
    active?: AdminConfirmationRequest;
    resolver?: (confirmed: boolean) => void;
  } => ({}),
  actions: {
    request(request: AdminConfirmationRequest): Promise<boolean> {
      this.active = request;
      return new Promise((resolve) => {
        this.resolver = resolve;
      });
    },
    resolve(confirmed: boolean): void {
      this.resolver?.(confirmed);
      delete this.active;
      delete this.resolver;
    },
  },
});
